import React, {useEffect, useState, useRef} from 'react'
import { createRoot } from 'react-dom/client'
import { SizeList } from './SizeList.jsx'
import { SpinnerDotted } from 'spinners-react'

const CrossSells = ( {productId} ) => {
	const [ crossSellProducts, setCrossSellProducts ] = useState([])
	const [ hasCrossSells, setHasCrossSells ] = useState( true )

	useEffect( () => {
		const getCrossSellProducts = async () => {
			const data = new FormData()

			data.append( 'nonce', robinshoes_ajax_obj.nonce )
			data.append( 'action', 'get_crosssells')
			data.append( 'productId', productId)

			const response = await fetch( robinshoes_ajax_obj.ajax_url, {
				method: 'POST',
				body: data
			})
			try {
				const result = await response.json()
				setCrossSellProducts( result.map( product  => {
					return (
						<li className='crosssell-list__item' key={product.url}>
							<span className="tooltip">
								{product.tooltip}
							</span>
							<a href={product.url}>
								<img src={product.image} alt="" />
							</a>
						</li>
					)
				}))
			} catch ( e ) {
				setHasCrossSells(false)
			}
		}
		getCrossSellProducts()
	}, [])

	return (
		<>
			{crossSellProducts.length > 0 &&
				<>
					<h4 className='product-crosssell-title'>Ook verkrijgbaar in:</h4>
					<ul className='product-crosssell-list'>
						{crossSellProducts}
					</ul>
				</>
			}
			{crossSellProducts.length === 0 && hasCrossSells &&
				<SpinnerDotted size="30" color="rgb(170, 143, 14)" />
			}
		</>
	)
}

const renderCrossSells = () => {
	[...document.getElementsByClassName('product-crosssells')].forEach( cs => {
		const root = createRoot(cs)
		const productId  = cs.getAttribute('data-productid')
		root.render(<CrossSells productId={productId} />)
	})
}

const renderSizes = () => {
	[...document.getElementsByClassName('product-archive-sizeswrapper')].forEach( sizes => {
		const root = createRoot(sizes)
		const productId  = sizes.getAttribute('data-productid')
		root.render(<SizeList productId={productId} />)
	})
}

window.renderCrossSells = renderCrossSells
window.renderSizes = renderSizes

renderCrossSells()
renderSizes()